import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CNavItem, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react-pro'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import matchContestNavigation from '../_nav_match_contest'
import adminNavigation from '../_nav_admin'
import CommonService from 'src/service/CommonService'
import GameEntryService from 'src/service/GameEntryService'
const adminDetails = JSON.parse(localStorage.getItem('admin'))

// entry_requirement 0 (public, instant join) and 3 (private, game code only) mean the
// "Verification Requirements" section in Game Entry Settings is hidden — mirrors
// `skipAdditionalSteps` in GameEntrySettings.js.
const NO_VERIFICATION_ENTRY_REQUIREMENTS = [0, 3]

const AppSidebar = () => {
  const [gameType, setGameType] = useState()
  const [externalPlayerList, setExternalPlayerList] = useState([])
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [externalPlayerStatus, setExternalPlayerStatus] = useState(0)
  const [externalPlayerTag, setExternalPlayerTag] = useState(0)
  const [showApprovals, setShowApprovals] = useState(false)
  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })

    CommonService.gameStructureInfo().then((res) => {
      if (res.status === 200) {
        setExternalPlayerStatus(res.game_data?.external_player_limit_status || 0)
        setExternalPlayerTag(res.game_data?.external_player_tag || 0)
        setExternalPlayerList(res.externalPlayerList || [])
      }
    })

    GameEntryService.getEntrySettings()
      .then((res) => {
        const entryRequirement = res?.data?.entry_requirement
        setShowApprovals(
          res.status === 200 &&
            entryRequirement !== undefined &&
            entryRequirement !== null &&
            !NO_VERIFICATION_ENTRY_REQUIREMENTS.includes(entryRequirement),
        )
      })
      .catch(() => {
        // Keep the default (hidden) if this can't be loaded.
      })
  }, [])
  const getTagNameById = (id, list) => {
    if (!id) return 'External Players'

    const tag = list?.find((item) => item.id === Number(id))
    return tag ? tag.name : 'External Players'
  }
  const updateNavigation = (nav, externalPlayerStatus, externalPlayerTag, externalPlayerList) => {
    const updatedNav = [...nav]

    const tagName = getTagNameById(externalPlayerTag, externalPlayerList)

    if (externalPlayerStatus === 1) {
      const playersMenu = updatedNav.find((item) => item.name === 'Players')

      if (playersMenu) {
        // ✅ IMPORT PAGE (THIS WAS MISSING)

        const importsMenu = updatedNav.find((item) => item.name === 'Imports')

        if (importsMenu) {
          const existsImport = importsMenu.items?.some((i) => i.to === '/external-player-import')

          if (!existsImport) {
            const squadsIndex = importsMenu.items.findIndex((i) => i.name === 'Squads')

            const importItem = {
              component: CNavItem,
              name: `${tagName} Import`,
              to: '/external-player-import',
            }

            if (squadsIndex !== -1) {
              // ✅ insert AFTER Squads inside Imports group
              importsMenu.items.splice(squadsIndex + 1, 0, importItem)
            } else {
              importsMenu.items.push(importItem)
            }
          }
        }
      }
    }

    // ✅ OPTIONAL: rename if already exists elsewhere
    updatedNav.forEach((item) => {
      if (item.to === '/external-player-import') {
        item.name = `${tagName} Import`
      }

      if (item.items) {
        item.items.forEach((subItem) => {
          if (subItem.to === '/external-player-import') {
            subItem.name = `${tagName} Import`
          }
        })
      }
    })

    return updatedNav
  }
  const modifiedNavigation = useMemo(() => {
    const nav = !externalPlayerList.length
      ? navigation // ⛔ wait for data
      : updateNavigation(navigation, externalPlayerStatus, externalPlayerTag, externalPlayerList)

    return showApprovals ? nav : nav.filter((item) => item.name !== 'Approvals')
  }, [externalPlayerStatus, externalPlayerTag, externalPlayerList, showApprovals])

  const modifiedMatchContestNavigation = useMemo(() => {
    if (!externalPlayerList.length) return matchContestNavigation

    return updateNavigation(
      matchContestNavigation,
      externalPlayerStatus,
      externalPlayerTag,
      externalPlayerList,
    )
  }, [externalPlayerStatus, externalPlayerTag, externalPlayerList])
  return (
    <CSidebar
      colorScheme="light"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/" style={{ backgroundColor: '#1f204e' }}>
        <img
          src="/images/mctlogo1.png"
          alt="logo"
          className="sidebar-brand-full"
          style={{ width: '80%' }}
        />
        <img
          src="/images/mctlogo1.png"
          alt="logo"
          className="sidebar-brand-narrow"
          style={{ width: '80%' }}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          {adminDetails?.user_role_id !== 1 && gameType === 4 && (
            <AppSidebarNav items={modifiedMatchContestNavigation} />
          )}

          {adminDetails?.user_role_id !== 1 && gameType !== 4 && (
            <AppSidebarNav items={modifiedNavigation} />
          )}

          {adminDetails?.user_role_id === 1 && <AppSidebarNav items={adminNavigation} />}
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
